import React from 'react';
import { useTranslate } from '@federico.moretti/react-translate';
import styled, { useTheme } from 'styled-components/macro';
import DetailsList from '../DetailsList';
import { Card } from '../../atoms';
import { Heading } from '../../typography';
import { SPACINGS, useMediaQuery } from '../../utils';

const ActionWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: ${SPACINGS[6]};
`;

type UserAddressesProps = {
  name: string;
  country: string;
  city: string;
  postCode: string | number;
  address: string;
  province: string;
  isResidential?: boolean;
  action?: React.ReactNode;
  style?: React.CSSProperties;
};
function UserAddresses(props: UserAddressesProps) {
  const {
    name,
    country,
    city,
    postCode,
    address,
    province,
    isResidential,
    action,
    style,
  } = props;
  const { t } = useTranslate();
  const theme = useTheme();

  const items = React.useMemo(
    () => [
      { label: t('address'), value: address },
      { label: t('postCode'), value: postCode },
      { label: t('city'), value: city },
      { label: t('country'), value: country },
      { label: t('province'), value: province },
    ],
    [address, city, country, postCode, province, t]
  );

  const isMobile = useMediaQuery(theme.mediaQueries.isMobile);

  return (
    <Card style={{ position: 'relative', ...style }}>
      {action && <ActionWrapper>{action}</ActionWrapper>}
      <Heading type={4}>
        {isResidential ? t('residentialAddress') : name}
      </Heading>
      <DetailsList
        items={items}
        cellStyle={
          isMobile
            ? {
                height: 40,
                paddingTop: SPACINGS[2],
                paddingBottom: SPACINGS[2],
              }
            : undefined
        }
      />
    </Card>
  );
}

export default UserAddresses;
